<div class="search">
  <div class="search__form">
    @if (config().isGamesSearchForm) {
      <form [formGroup]="gamesFilters.state().searchForm">
        <app-form-input [control]="gamesFilters.state().searchForm.get('search')" [label]="'t.search' | translate">
          <div class="icon-block">
            <i class="icon-arrow"></i>
          </div>
          <input
            #inputRef
            (keydown.enter)="onBlurInput()"
            formControlName="search"
            type="text"
            class="input input--simple">
        </app-form-input>
      </form>
    }
    @if (config().isMainSearchForm) {
      <form [formGroup]="gamesFilters.state().searchFormMain">
        <app-form-input [control]="gamesFilters.state().searchFormMain.get('search')" [label]="'t.search' | translate">
          <div (click)="onGoSearch()" class="icon-block">
            <i class="icon-arrow"></i>
          </div>
          <input
            (focus)="onFocusInput()"
            (keydown.enter)="onGoSearch()"
            formControlName="search"
            type="text"
            class="input input--simple">
        </app-form-input>
      </form>
    }
    @if (config().isSideNavSearchForm) {
      <form [formGroup]="gamesFilters.state().searchFormSideNav">
        <app-form-input [control]="gamesFilters.state().searchFormSideNav.get('search')"
                        [label]="'t.search' | translate">
          <div class="icon-block">
            <i class="icon-arrow"></i>
          </div>
          <input
            formControlName="search"
            type="text"
            class="input input--simple">
        </app-form-input>
      </form>
    }
  </div>
</div>
